var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoading),expression:"!isLoading"}],attrs:{"id":"canvas","width":_vm.getWidth,"height":_vm.getHeight}})}
var staticRenderFns = []

export { render, staticRenderFns }